import React, { useEffect, useMemo, useRef, useState } from 'react'

import Payment from '@solidgate/react-sdk'

import { func, object, string } from 'prop-types'

function PaymentForm({
  merchant,
  signature,
  paymentIntent,
  styles = null,
  formParams = null,
  googlePayButtonParams = null,
  applePayButtonParams = null,
  paypalButtonParams = { enabled: true },
  onSuccess = null,
  onFail = null,
  onError = null,
  onVerify = null,
  onReadyPaymentInstance = null,
  onSubmit = null,
  onInteraction = null,
  googlePayContainerRef: externalGoogleRef = null,
  applePayContainerRef: externalAppleRef = null,
  paypalContainerRef: externalPaypalRef = null,
}) {
  const internalAppleRef = useRef(null)
  const internalGoogleRef = useRef(null)
  const internalPaypalRef = useRef(null)

  const useExternalRefs = externalGoogleRef || externalAppleRef || externalPaypalRef
  const appleContainerRef = externalAppleRef || internalAppleRef
  const googleContainerRef = externalGoogleRef || internalGoogleRef
  const paypalContainerRef = externalPaypalRef || internalPaypalRef

  // Defer one tick so the SDK initializes after the wallet ref nodes are attached
  // — the SDK reads container refs synchronously on mount and the first-render
  // commit may not have flushed them yet on SSR hydration.
  const [isHydrated, setIsHydrated] = useState(false)
  useEffect(() => { setIsHydrated(true) }, [])

  // Stable reference — a new object on every render makes the SDK re-init the wallet iframes.
  const merchantData = useMemo(
    () => ({ merchant, signature, paymentIntent }),
    [merchant, signature, paymentIntent]
  )

  return (
    <div className="payment-form">
      {!useExternalRefs && (
        <>
          <div ref={internalGoogleRef} className="payment-form__google-pay" />
          <div ref={internalAppleRef} className="payment-form__apple-pay" />
          <div ref={internalPaypalRef} className="payment-form__paypal" />
        </>
      )}
      {isHydrated && (
        <Payment
          merchantData={merchantData}
          styles={styles}
          formParams={formParams}
          googlePayButtonParams={googlePayButtonParams}
          applePayButtonParams={applePayButtonParams}
          paypalButtonParams={paypalButtonParams}
          googlePayContainerRef={googleContainerRef}
          applePayContainerRef={appleContainerRef}
          paypalContainerRef={paypalContainerRef}
          onSuccess={onSuccess}
          onFail={onFail}
          onError={onError}
          onVerify={onVerify}
          onReadyPaymentInstance={onReadyPaymentInstance}
          onSubmit={onSubmit}
          onInteraction={onInteraction}
        />
      )}
    </div>
  )
}

PaymentForm.propTypes = {
  merchant: string.isRequired,
  signature: string.isRequired,
  paymentIntent: string.isRequired,
  styles: object,
  formParams: object,
  googlePayButtonParams: object,
  applePayButtonParams: object,
  paypalButtonParams: object,
  onSuccess: func,
  onFail: func,
  onError: func,
  onVerify: func,
  onReadyPaymentInstance: func,
  onSubmit: func,
  onInteraction: func,
  googlePayContainerRef: object,
  applePayContainerRef: object,
  paypalContainerRef: object,
}

export default PaymentForm
